import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="foldable-group"
export default class extends Controller {
  static targets = ["foldBtn", "expandBtn"]
  static outlets = ["foldable"]
  connect() {
    this.syncButtonState()
  }

  foldableOutletConnected(outlet) {
    outlet.element.addEventListener("foldable:changed", this.syncButtonState.bind(this))
  }

  foldAll() {
    this.foldableOutlets.forEach(foldable => {
      foldable.fold()
    })
  }

  expandAll() {
    this.foldableOutlets.forEach(foldable => {
      foldable.expand()
    })
  }

  isAllFolded() {
  return [...this.foldableOutlets].every(foldable => foldable.foldedValue)
  }

  syncButtonState() {
    const allFolded = [...this.foldableOutlets].every(foldable => foldable.foldedValue)
    const allExpanded = [...this.foldableOutlets].every(foldable => !foldable.foldedValue)

    switch (true) {
      case allFolded:
        this._showExpandBtn()
        break
      case allExpanded:
        this._showFoldBtn()
        break
      default:
        this._showExpandBtn()
    }

  }

  _showExpandBtn() {
    this.expandBtnTarget.classList.remove("hidden")
    this.foldBtnTarget.classList.add("hidden")
  }

  _showFoldBtn() {
    this.expandBtnTarget.classList.add("hidden")
    this.foldBtnTarget.classList.remove("hidden")
  }
}
